import type { EmployeeAwardDefinition, EmployeeAwardGrant, User } from '../types';

export function buildGrantPayloadFromDefinition(
  definition: EmployeeAwardDefinition,
  userId: string,
  grantedBy: string,
  grantNote?: string,
): Omit<EmployeeAwardGrant, 'id' | 'grantedAt'> {
  return {
    userId,
    awardDefinitionId: definition.id!,
    awardName: definition.name,
    awardDescription: definition.description,
    iconUrl: definition.iconUrl,
    grantedBy,
    ...(grantNote?.trim() ? { grantNote: grantNote.trim() } : {}),
  };
}

export function shouldShowAwardGrant(
  grant: EmployeeAwardGrant | null,
  user: User | null,
  sessionDismissedIds: string[] = [],
): boolean {
  if (!grant || !user || !grant.id) return false;
  if (grant.userId !== user.id) return false;
  if (user.seenAwardGrantIds?.includes(grant.id)) return false;
  if (sessionDismissedIds.includes(grant.id)) return false;
  return true;
}

/** Oldest unseen grant first (queue order for unlock popups). */
export function pickNextUnseenAwardGrant(
  grants: EmployeeAwardGrant[],
  seenIds: string[] | undefined,
  sessionDismissedIds: string[] = [],
): EmployeeAwardGrant | null {
  const seen = new Set(seenIds ?? []);
  for (const g of grants) {
    if (!g.id) continue;
    if (seen.has(g.id)) continue;
    if (sessionDismissedIds.includes(g.id)) continue;
    return g;
  }
  return null;
}
